import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { DroneSpecificationDto } from 'src/app/dto/droneSpecification/droneSpecification.dto';
import { FlightConfigurationDto } from 'src/app/dto/flightConfiguration/flightConfiguration.dto';
import { UnitDto } from 'src/app/dto/unit/unit.dto';
import { DroneSpecificationComponent } from '../droneSpecification/droneSpecification.component';
import { FlightConfiguraitonComponent } from '../flightConfiguration/flightConfiguration.component';

@Component({
    selector: "configuration",
    templateUrl: '../../view/configuration/configuration.html'
})
export class ConfigurationComponent {
    public isContainedGust: boolean = false;
    public isVisibleFlightConfigurationSetting: boolean = false;
    public isVisibleUnitSetting: boolean = false;
    public accountSeq?: number;

    @Output() public getChangeGustEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() public getChangeUnitEvent: EventEmitter<UnitDto> = new EventEmitter<UnitDto>();
    @Output() public getChangeFlightConfigEvent: EventEmitter<FlightConfigurationDto> = new EventEmitter<FlightConfigurationDto>();
    @Output() public toggleOverlayEvent: EventEmitter<void> = new EventEmitter<void>();

    @ViewChild(FlightConfiguraitonComponent) private flightConfigurationComponent!: FlightConfiguraitonComponent;
    @ViewChild(DroneSpecificationComponent) private droneSpecificationComponent!: DroneSpecificationComponent;

    constructor() {}

    public getFlightConfiguration(): void {
        this.flightConfigurationComponent.getFlightConfigratuion();
    }

    public changeContainsGust(): void {
        this.isContainedGust = !this.isContainedGust;

        this.getChangeGustEvent.emit(this.isContainedGust);
    }

    public changeDrone(droneSpecifationDto: DroneSpecificationDto): void {
        this.flightConfigurationComponent.setDroneSpecifitiaon(droneSpecifationDto);
    }

    public changeFlightConfigInfoEvent(flightConfigurationDto: FlightConfigurationDto): void {
        this.getChangeFlightConfigEvent.emit(flightConfigurationDto);
        this.droneSpecificationComponent.setSavedDrone(flightConfigurationDto);
    }

    public changeUnitEvent(unitDto: UnitDto): void {
        this.flightConfigurationComponent.setUserUnit(unitDto);
        this.getChangeUnitEvent.emit(unitDto);
    }

    public toggleFlightConfigurationSettingVisible(): void {
        this.isVisibleFlightConfigurationSetting = !this.isVisibleFlightConfigurationSetting;
    }

    public toggleUnitSettingVisible(): void {
        this.isVisibleUnitSetting = !this.isVisibleUnitSetting;

        if (this.isVisibleUnitSetting) {
            this.toggleOverlayEvent.emit();
        }
    }

    protected readonly localStorage = localStorage;
}
